import { css } from '@emotion/css';
import React from 'react';
import { FadeInImage } from 'src/components/shared/FadeInImage';

interface FamilyIconProps {
  family: 'kappei-family' | 'able-sisters';
  iconHeight: number;
}

export const FamilyIcon: React.FC<FamilyIconProps> = ({ family, iconHeight }) => {
  return (
    <div
      className={css`
        img {
          display: inline-block;
          width: auto;
          height: ${iconHeight}px;
          margin: 0 auto;
        }
      `}
    >
      {(() => {
        switch (family) {
          case 'kappei-family':
            return (
              <FadeInImage src="/images/resort/npcs/kappei-family.png" width={969} height={256} />
            );
          case 'able-sisters':
            return (
              <FadeInImage src="/images/resort/npcs/able-sisters.png" width={731} height={256} />
            );
        }
      })()}
    </div>
  );
};
